export default "__VITE_ASSET__D36zhiJB__"